import { render, staticRenderFns } from "./MedcertForeingWorkersDialog.vue?vue&type=template&id=74ba5df6&scoped=true&"
import script from "./MedcertForeingWorkersDialog.vue?vue&type=script&lang=js&"
export * from "./MedcertForeingWorkersDialog.vue?vue&type=script&lang=js&"
import style0 from "./MedcertForeingWorkersDialog.vue?vue&type=style&index=0&id=74ba5df6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ba5df6",
  null
  
)

export default component.exports